import { connectRouter, routerMiddleware } from 'connected-react-router';
import createHistory from 'history/createBrowserHistory'; // eslint-disable-line import/no-extraneous-dependencies
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import app, { statusReducer as status } from '../features/App/reducer';
import { reducer as button } from '../features/Button';
import menu from '../features/DefaultLayout/reducer';
import documents from '../features/FileHandler/reducer';
import { reducer as form } from '../features/Form';
import notificationBar from '../features/NotificationBar/reducer';
import { reducer as application } from '../features/Application';

export const history = createHistory();

const rootReducer = combineReducers({
  app,
  application,
  button,
  documents,
  form,
  menu,
  notificationBar,
  status,
});

const initialState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__; // eslint-disable-line no-underscore-dangle

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export default createStore(
  connectRouter(history)(rootReducer),
  initialState,
  composedEnhancers
);



// WEBPACK FOOTER //
// ./src/features/store.js